import React, { type JSX } from 'react';

import { useTenantDetailsContext } from '@/shared/data/contexts/TenantDetailsContext';
import { TrpcProvider } from '@/shared/data/contexts/TrpcProvider';
import { ErrorBoundaryClearedOnNavigation } from '@/shared/ui/errors/ErrorBoundaryClearedOnNavigation';

/** The tRPC provider every page sits under, public or signed in; its requests carry the session's token. */
export function AppWithAuth({ children }: { children: React.ReactNode }): JSX.Element {
    const { tenantDetails } = useTenantDetailsContext();

    React.useEffect(() => {
        window.document.title = tenantDetails.organization_name;
        // The link preview title, for tools that read the open page. Crawlers run no JavaScript and keep the
        // fixed one from index.html.
        window.document
            .querySelector('meta[property="og:title"]')
            ?.setAttribute('content', tenantDetails.organization_name);
    }, [tenantDetails.organization_name]);

    return (
        <ErrorBoundaryClearedOnNavigation>
            <TrpcProvider>{children}</TrpcProvider>
        </ErrorBoundaryClearedOnNavigation>
    );
}
